import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import './banner.scss';
import useLadyService from '@/services/LadyService';
import { useSelector } from 'react-redux';
import { getUserCurrentCity } from '@/stores/slices/userSlice';

import { useParams } from 'react-router-dom';
import { getDisabledFilters } from '@/stores/slices/filterSlice';

const AdvertBanner = ({ type }) => {
	const { lang } = useLadyService();

	const { city: currentCityURLParam } = useParams();

	const disabled_filters = useSelector(getDisabledFilters);

	const disabled = useMemo(() => {
		return new Set(disabled_filters);
	}, [disabled_filters]);

	const hasAds = useMemo(() => {
		return !disabled.has(type === 'video' ? 'tagVideochat' : 'tagEro');
	}, [disabled_filters, type]);

	const currentCityParam = currentCityURLParam?.split('_')[0];

	const cityCurrent = useSelector(getUserCurrentCity);

	const { t } = useTranslation('translation');

	return (
		<a
			href={
				type === 'video'
					? `/${lang}/${
							hasAds
								? (currentCityParam ?? cityCurrent.slug)
								: 'czechia'
						}/vchat`
					: `/${lang}/${
							hasAds
								? (currentCityParam ?? cityCurrent.slug)
								: 'czechia'
						}/ero`
			}
			className={`banner __container advert-banner ${type} invisible`}
		>
			<p className="td-none banner-head ">
				{type === 'video' ? t('modelsforvideo') : t('erocontent')}
			</p>

			<p className="banner-text td-none ">
				{type === 'video' ? (
					`${t('meetbefore')}!`
				) : (
					<>
						{`${t('modelsshare')} `}

						<strong>{t('picfotosvideos')}</strong>
					</>
				)}
			</p>
		</a>
	);
};

const MemoBanner = React.memo(AdvertBanner);

export default MemoBanner;
